import { Navigate, useParams } from 'react-router-dom';
import { getStoredEventSlug, normalizeEventSlug } from '@/helpers/eventSlug';
import { clearStoredInviteToken } from '@/helpers/inviteToken';
import { clearOnboardingGuest } from '@/helpers/onboardingGuest';
import { getStoredTenantSlug, normalizeTenantSlug } from '@/helpers/tenantSlug';
import type { ErrorLocationState } from '@/Pages/Error/types/errorLocationState';

const NOT_FOUND_STATE: ErrorLocationState = { errorType: 'not_found' };

/**
 * Rota de entrada `/{slug}`: o bootstrap (main.tsx) já resolveu, validou e
 * persistiu o slug — de EVENTO (https://foto.identila.com.br/<event-slug>) ou
 * de TENANT (linha store) — e aqui só redirecionamos para o início do funil.
 * Um path que não corresponde a nenhum slug validado é rota desconhecida → 404.
 */
export function TenantSlugRoute() {
  const { tenantSlug } = useParams();

  const eventSlug = normalizeEventSlug(tenantSlug);
  if (eventSlug !== null && eventSlug === getStoredEventSlug()) {
    // URL do evento (convite COM CPF) é entrada nova: o link pessoal e o
    // convidado de uma visita anterior nesta aba não são de quem chegou agora
    // — o token jogaria o /identify de volta no "Você é Fulano?" de outro.
    clearStoredInviteToken();
    clearOnboardingGuest();
    return <Navigate to="/welcome" replace />;
  }

  const slug = normalizeTenantSlug(tenantSlug);
  if (slug !== null && slug === getStoredTenantSlug()) {
    return <Navigate to="/welcome" replace />;
  }

  return <Navigate to="/error" replace state={NOT_FOUND_STATE} />;
}
